import React, { FC, useContext } from 'react'
import { HistoryContext } from '../../../../contexts/HistoryContext'
import Link from 'next/link'
import { IoIosArrowBack } from 'react-icons/io'
import { useItemPage } from '@components/ItemPage/Layout/ItemPageContext'

const BackButton: FC = () => {
  const {
    auction,
    itemState: { id },
    pageNumber,
  } = useItemPage()
  const history: any = useContext(HistoryContext)
  const prevUrl = history?.path?.prev || ''

  const getUrl = () => {
    if (!prevUrl) return `/auction-detail/${auction?.id}/${pageNumber}`
    if (
      prevUrl.includes(`/auction-detail/${auction?.id}`) ||
      prevUrl.includes('saved-search')
    )
      return prevUrl.includes('?')
        ? `${prevUrl}&itemId=${id}`
        : `${prevUrl}?itemId=${id}`

    return `/auction-detail/${auction?.id}/${pageNumber}`
  }

  const isAuctionPreviousPage = !prevUrl.includes('/items?')

  return (
    <div className="flex flex-col gap-2 w-full">
      <Link href={isAuctionPreviousPage ? getUrl() : prevUrl}>
        <button className="font-bold flex items-center tracking-tighter gap-2">
          <IoIosArrowBack />
          {isAuctionPreviousPage ? 'BACK TO AUCTION' : 'BACK TO ITEM SEARCH'}
        </button>
      </Link>
    </div>
  )
}

export default BackButton
